// extracted by mini-css-extract-plugin
module.exports = {"grid":"vendor-grid_grid__2TI1L"};